import { render } from "./EmbedCode.vue?vue&type=template&id=45653f1a&scoped=true"
import script from "./EmbedCode.vue?vue&type=script&lang=js"
export * from "./EmbedCode.vue?vue&type=script&lang=js"

import "./EmbedCode.vue?vue&type=style&index=0&id=45653f1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45653f1a"]])

export default __exports__